import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateLayloConfigurationMutation = createMutationHook(
  CreatorIntegrationsApiClient.updateLayloConfiguration,
  {
    mutationKey: ['updateLayloConfiguration'],
  },
)
